import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6068aaee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/tickets/_tickets.scss?vue&type=style&index=0&id=6068aaee&prod&scoped=true&lang=scss&"
import style1 from "@/assets/scss/mobile/tutorial/tutorial.scss?vue&type=style&index=1&id=6068aaee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6068aaee",
  null
  
)

export default component.exports